import React, { FC } from "react";

const ListItemIcon: FC<{ selected: boolean }> = ({ selected }) => {
  const faClass = selected ? "fa fa-circle" : "fa fa-circle-thin";
  return <i className={faClass} style={{ fontSize: 25 }} />;
};

export default ListItemIcon;
